import { Colors } from '../Colors';

const picker = {
    root: {
        background: '#ECF0FB',
        color: Colors.text,
        cursor: 'pointer',
        height: '2rem',
    },
    label: {
        lineHeight: '2rem',
    }
};

export default {
    styles: (_, { variant }) => {
        if (variant === 'picker') {
            return picker;
        }
        return {};
    },
};
